<dx-popup
  [width]="300"
  [height]="250"
  [showTitle]="true"
  title="Information"
  [dragEnabled]="false"
  [closeOnOutsideClick]="true"
  [visible]="visible">
  <div *dxTemplate="let data of 'content'">
    qsdqdqsdqsdqsd
  </div>
</dx-popup>
